import { atom } from 'jotai'
import { TAddressHistoryItem } from '../types/address-history.type'

/**
 * Is this a REAL selection? "Nothing selected" reaches consumers in three shapes — the atom's
 * default below (every field present, all empty), the `{}` written by page cleanups, and an
 * entry that genuinely has an address. Testing `selected?.shipToAddress` therefore answers
 * "yes" for the default and sends a blank ship-to downstream; the only reliable signal is a
 * non-empty displayAddress (or a name, for entries typed on-screen before display is built).
 */
export const isAddressSelected = (a?: TAddressHistoryItem | null): boolean => !!(a?.displayAddress?.trim() || a?.shipToAddress?.address1?.trim())

export const addressHistorySelectedState = atom<TAddressHistoryItem>({
    addressHref: '',
    shipToAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
    },
    shipToName: {
        firstName: '',
        lastName: '',
        fullName: ''
    },
    shipToOptionId: {
        unicity: ''
    },
    ushopShipToName: '',
    shipment_options: '',
    address_id: '',
    displayType: '',
    displayAddress: ''
})
